export function maskDocument(value) {
  // CPF é sempre numérico (11 dígitos). CNPJ alfanumérico (IN RFB 2.119/2022)
  // permite letras nas 12 primeiras posições; os 2 dígitos verificadores
  // finais continuam sempre numéricos.
  const raw = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
  const hasLetter = /[A-Z]/.test(raw)

  if (!hasLetter && raw.length <= 11) {
    return raw
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  }

  let clean = raw.slice(0, 14)
  if (clean.length > 12) clean = clean.slice(0, 12) + clean.slice(12).replace(/\D/g, '')
  return clean
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
    .replace(/([A-Z0-9]{4})(\d)/, '$1-$2')
    .slice(0, 18)
}
